import { render, staticRenderFns } from "./leftHome.vue?vue&type=template&id=671fd968&scoped=true&"
import script from "./leftHome.vue?vue&type=script&lang=js&"
export * from "./leftHome.vue?vue&type=script&lang=js&"
import style0 from "./leftHome.vue?vue&type=style&index=0&id=671fd968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671fd968",
  null
  
)

export default component.exports